import { PERSONAL_LOAN_STEPS, STAGE } from "../constants";
import { REPEAT_PERSONAL_LOAN_STEPS, RPL_PROGRESS_MAP, stageMapRPL } from "../utils/rpl.utils";

const useProgressHook = (stage, isRPL) => {
  const stageMap = {
    [STAGE.LOAN_AMOUNT]: "Personal Details",
    [STAGE.PAN]: "Personal Details",
    [STAGE.CKYC]: "Personal Details",
    [STAGE.ADD_ADDRESS]: "Personal Details",
    [STAGE.PERSONAL_DETAILS]: "Personal Details",
    [STAGE.OFFERS]: "Loan Offer",
    [STAGE.DIGI_KYC]: "KYC Verification",
    [STAGE.EKYC]: "KYC Verification",
    [STAGE.WORK_DETAILS]: "Work Details",
    [STAGE.MANDATE]: "Re-Payment Setup",
    [STAGE.MANDATE_PENNYDROP]: "Re-Payment Setup",
    [STAGE.VKYC]: "Re-Payment Setup",
    [STAGE.VKYC_SCHEDULED]: "Re-Payment Setup",
    [STAGE.RPD_MODE]: "Re-Payment Setup",
    [STAGE.REVERSE_PENNY_DROP]: " Re-Payment Setup",
    [STAGE.E_SIGN]: "E-Sign",
    [STAGE.E_SIGN_KFS_INCOMPLETE]: "E-Sign",
    [STAGE.BRE_CPV_TVR]: "BRE_CPV_TVR",
    [STAGE.LMS_ONBOARDING]: "BRE_CPV_TVR",
  };
  const ProgressMap = {
    [STAGE.LOAN_AMOUNT]: 10,
    [STAGE.PAN]: 10,
    [STAGE.CKYC]: 10,
    [STAGE.ADD_ADDRESS]: 10,
    [STAGE.PERSONAL_DETAILS]: 10,
    [STAGE.OFFERS]: 20,
    [STAGE.DIGI_KYC]: isRPL ? 40 : 80,
    [STAGE.EKYC]: 40,
    [STAGE.WORK_DETAILS]: 60,
    [STAGE.MANDATE]: 80,
    [STAGE.MANDATE_PENNYDROP]: 80,
    [STAGE.VKYC]: 80,
    [STAGE.VKYC_SCHEDULED]: 80,
    [STAGE.RPD_MODE]: 80,
    [STAGE.REVERSE_PENNY_DROP]: 80, 
    [STAGE.E_SIGN]: 90,
    [STAGE.E_SIGN_KFS_INCOMPLETE]: 90,
    [STAGE.BRE_CPV_TVR]: 100,
    [STAGE.LMS_ONBOARDING]: 100,
  };

  const percentProgressMap = isRPL ? RPL_PROGRESS_MAP : ProgressMap;
  const progressStepsList = isRPL ? REPEAT_PERSONAL_LOAN_STEPS : PERSONAL_LOAN_STEPS;
  const currentStep =  isRPL ? stageMapRPL[stage] : stageMap[stage];

  if (stage === STAGE.BRE_CPV_TVR || stage === STAGE.LMS_ONBOARDING) {
    return {
      activeStage: progressStepsList?.length - 1,
      progressValue: percentProgressMap[stage] || 100,
    };
  }
  const index = progressStepsList?.indexOf(currentStep);
  return {
    activeStage: index === -1 ? 0 : Math.max(0, index),
    progressValue: percentProgressMap[stage] || 0,
  };
};

export default useProgressHook;
